/**
 * Copyright (c) 2020 TechDivision GmbH
 * All rights reserved
 */

/**
 * @module navigation
 */
(function () {

    /**
     * Handle navigation
     * @param mainNav {String} mainNav identifier
     * @method navigation
     */
    function Navigation(mainNav) {
        /**
         * // local object availability
         * @type {navigation}
         * @private
         */
        var _this = this;

        /**
         * @type {element}
         */
        this.mainNav = mainNav;

        /**
         * @method cacheDom
         *  assign {|HTMLElement(s)} to object
         */
        this.cacheDom = function () {
            this.body = document.querySelector('body');
        };

        /**
         * @method init
         * @returns {undefined}
         */
        this.init = function () {
            _this.cacheDom();
            _this.bindEvents();
        };

        /**
         * @method bindEvents
         * @return {undefined}
         */
        this.bindEvents = function () {
            var toggleButton = _this.mainNav.querySelector('[data-js="navigation-toggle-button"]');
            toggleButton.addEventListener("click", function () {
                _this.body.classList.toggle('js__show-off-canvas-menu');
            });

            var mobileNavigationOverlayMask = _this.mainNav.querySelector('[data-js="mobile-navigation-overlay-mask"]');
            mobileNavigationOverlayMask.addEventListener("click", function () {
                _this.body.classList.toggle('js__show-off-canvas-menu');
            });

            var subMenuCTAs = _this.mainNav.querySelectorAll('[data-js="nav-sub"]');
            Object.keys(subMenuCTAs).forEach(function (key) {
                var currentItem = subMenuCTAs[key];
                currentItem.addEventListener("click", function () {
                    var submenu = this.parentNode.querySelector('.main-nav--sub');
                    submenu.classList.add('visible');
                });
            });

            var subMenuCTAsBack = _this.mainNav.querySelectorAll('[data-js="nav-sub-back"]');
            Object.keys(subMenuCTAsBack).forEach(function (key) {
                var currentItem = subMenuCTAsBack[key];
                currentItem.addEventListener("click", function () {
                    this.closest('.main-nav--sub').classList.remove('visible');
                });
            });

            var subMenuShowChildren = _this.mainNav.querySelectorAll('[data-js="nav-sub-show-children"]');
            Object.keys(subMenuShowChildren).forEach(function (key) {
                var currentItem = subMenuShowChildren[key];
                currentItem.addEventListener("click", function () {
                    this.nextSibling.classList.toggle('show-children');
                    this.classList.toggle('active')
                });
            });
        };

        /**
         * initialize call navigation
         */
        _this.init();
    }

    // define the global scope
    if (!window.Jumpers) {
        window.Jumpers = {};
    }

    window.Jumpers.Navigation = Navigation;
})();

$(function () {
    var mainNavContainer = document.querySelector('[data-html-element="main-nav-container"]');
    if (mainNavContainer) {
        new window.Jumpers.Navigation(mainNavContainer);
    }
});
